module.exports = __webpack_public_path__ + "img/ic_48_faq_up.2cd9741f.svg";